export enum MembershipState {
    UNKNOWN = 'UNKNOWN',
    PENDING = 'PENDING',
    ACCEPTED = 'ACCEPTED',
    DENIED = 'DENIED',
}